import isHybridEnabledCSR from '@/app/api/CSR/isHybridEnabledCSR'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { goToHome as goToHomeCSR } from './goToHome'

export const goToHomeHybridMod = (router: AppRouterInstance) => {
  const hybridAction = () => {
    if (isHybridEnabledCSR()) {
      if (typeof window !== 'undefined') {
        window.location.href = '/'
      }
    } else {
      goToHomeCSR(router)
    }
  }

  return hybridAction()
}
